module.exports = __webpack_public_path__ + "static/media/section-1@3x.9ab9be72.png";